/**
 * Yotpo BottomLine Accessibility Fixer
 * Resolves ARIA role and keyboard navigation issues on the Yotpo Star Rating widget.
 */
(function() {
  'use strict';

  function fixBottomLineWidgets() {
    const widgets = document.querySelectorAll('.yotpo-bottomline.star-clickable:not([data-a11y-fixed])');
    
    widgets.forEach(widget => {
      // The widget has tabindex="0" but no semantic role. Screen readers won't know it's a link.
      widget.setAttribute('role', 'link');
      
      // The child <a> tag inside it usually contains the aria-label (e.g. "1900 reviews").
      // We also look for the screen-reader-only text containing the star rating (e.g. "4.4 star rating").
      const innerLink = widget.querySelector('a.text-m');
      const starRatingSpan = widget.querySelector('.yotpo-stars .sr-only');
      
      let newLabel = '';
      
      if (starRatingSpan && starRatingSpan.textContent) {
        newLabel += starRatingSpan.textContent.trim() + ', ';
        // Hide the original span from screen readers so it's not read twice
        starRatingSpan.setAttribute('aria-hidden', 'true');
      }

      if (innerLink && innerLink.hasAttribute('aria-label')) {
        newLabel += 'Read ' + innerLink.getAttribute('aria-label');
        
        // Remove tabindex="-1" from the inner link to avoid nested focus confusion
        innerLink.removeAttribute('tabindex');
        // Hide the inner link from screen readers to prevent redundant announcements
        innerLink.setAttribute('aria-hidden', 'true');
      } else {
        newLabel += 'Read reviews';
      }
      
      widget.setAttribute('aria-label', newLabel);

      // Add keyboard event listener to trigger the click event on Enter or Space
      widget.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          widget.click();
        }
      });
      
      // Mark as fixed so we don't process it multiple times
      widget.setAttribute('data-a11y-fixed', 'true');
    });
  }

  function initFixer() {
    // Run initially
    fixBottomLineWidgets();

    // Set up MutationObserver to catch Yotpo widgets injected asynchronously
    const observer = new MutationObserver(mutations => {
      let shouldProcess = false;
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if added node is or contains a yotpo-bottomline
            if (node.matches('.yotpo-bottomline') || node.querySelector('.yotpo-bottomline')) {
              shouldProcess = true;
              break;
            }
          }
        }
        if (shouldProcess) break;
      }
      
      if (shouldProcess) {
        // Debounce slightly to allow Yotpo to finish rendering its inner HTML
        setTimeout(fixBottomLineWidgets, 100);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
    
    // Fallback interval since Yotpo loads very late on some connections
    let checks = 0;
    const interval = setInterval(() => {
      fixBottomLineWidgets();
      checks++;
      if (checks > 15) clearInterval(interval); // Stop checking after 15 seconds
    }, 1000);
  }

  // Auto-initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFixer);
  } else {
    initFixer();
  }
})();
